import CustomIcon, { ICustomIconProps } from '../_CustomIcon';
import { ReactComponent as IconComponent } from './Icon.svg';

const TrashIcon = (props: ICustomIconProps) => <CustomIcon icon={IconComponent} {...props} />;

export default TrashIcon;
